import { render, staticRenderFns } from "./constructionRelactionTaskSafetyCheck.vue?vue&type=template&id=3f2da3c4"
import script from "./constructionRelactionTaskSafetyCheck.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTaskSafetyCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2da3c4')) {
      api.createRecord('3f2da3c4', component.options)
    } else {
      api.reload('3f2da3c4', component.options)
    }
    module.hot.accept("./constructionRelactionTaskSafetyCheck.vue?vue&type=template&id=3f2da3c4", function () {
      api.rerender('3f2da3c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTaskSafetyCheck.vue"
export default component.exports